// core/domain/UniqueEntityID.ts
import { v4 as uuid } from "uuid";

export class UniqueEntityID {
  constructor(private readonly value: string = uuid()) {}
  toValue(): string {
    return this.value;
  }
}
